export default __webpack_public_path__ + "static/media/d-dog.fa16ef6a.png";